/* Zareen Jewels — product rail arrows (works for rails that are re-rendered later too) */
(() => {
  if (window.zjRailReady) return;
  window.zjRailReady = true;
  const sync = (rail) => {
    const root = rail.closest('[data-zjv]');
    if (!root) return;
    const [prev, next] = root.querySelectorAll('[data-zjv-go]');
    const max = rail.scrollWidth - rail.clientWidth;
    if (prev) prev.disabled = rail.scrollLeft <= 4;
    if (next) next.disabled = rail.scrollLeft >= max - 4;
  };
  const syncAll = () => document.querySelectorAll('[data-zjv-rail]').forEach(sync);
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-zjv-go]');
    if (!b) return;
    const rail = b.closest('[data-zjv]').querySelector('[data-zjv-rail]');
    rail.scrollBy({ left: Number(b.dataset.zjvGo) * rail.clientWidth * 0.8, behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('[data-zjv-rail]')) requestAnimationFrame(() => sync(t));
  }, true);
  window.addEventListener('resize', syncAll, { passive: true });
  document.addEventListener('zj:rendered', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();
